import {createAction} from "@reduxjs/toolkit";

export const setSession = createAction('SET_SESSION');